import React, { useMemo } from "react";
import "./patientTextDetails.css";
const PatientTextDetails = ({ patientDetailsData }) => {
  const patientPhoneNumber = useMemo(() => {
    return patientDetailsData?.resource?.telecom?.find(
      (item) => item.system === "phone"
    );
  }, [patientDetailsData?.resource?.telecom]);

  const patientAge = useMemo(() => {
    return patientDetailsData?.resource?.extension?.find((item) =>
      item.url.includes("age")
    );
  }, [patientDetailsData?.resource]);

  const inpatientNumber = useMemo(() => {
    return patientDetailsData?.resource?.identifier?.find((item) =>
      item.system.includes("inpatient")
    );
  }, [patientDetailsData?.resource?.identifier]);

  return (
    <div className="info">
      <div>
        <span className="label">Name - </span>{" "}
        {patientDetailsData.resource.name[0].given[0] +
          " " +
          patientDetailsData.resource.name[0].family}
      </div>
      {patientDetailsData.resource.gender && (
        <div>
          <span className="label">Gender - </span>{" "}
          {patientDetailsData.resource.gender}
        </div>
      )}

      {patientPhoneNumber && (
        <div>
          <span className="label">Phone - </span> {patientPhoneNumber?.value}
        </div>
      )}
      {patientAge && (
        <div>
          <span className="label">Age - </span>
          {patientAge?.valueCode}
        </div>
      )}
      {inpatientNumber && (
        <div>
          <span className="label">Inpatient Number - </span>
          {inpatientNumber.value}
        </div>
      )}
    </div>
  );
};

export default PatientTextDetails;
